var _defs, _path, _path2, _path3, _rect, _rect2, _rect3, _polygon, _path4, _path5, _polygon2, _polygon3, _polygon4, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPoweredByFooter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Logo",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 440 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M216.91,134.72a1.58,1.58,0,0,1,.62,1.31,1.62,1.62,0,0,1-.09.57,1.65,1.65,0,0,1-.22.44,1.93,1.93,0,0,1-.31.33,4,4,0,0,1-.38.24,2.63,2.63,0,0,1,.56.25,1.7,1.7,0,0,1,.44.35,1.49,1.49,0,0,1,.29.47,2,2,0,0,1,.1.63,1.81,1.81,0,0,1-.19.83,1.79,1.79,0,0,1-.52.61,2.69,2.69,0,0,1-.82.37,4.35,4.35,0,0,1-1.06.12h-3.24v-7h3.14A2.7,2.7,0,0,1,216.91,134.72ZM216,137a.79.79,0,0,0,.35-.72.77.77,0,0,0-.31-.67,1.47,1.47,0,0,0-.91-.24h-1.76v1.87H215A1.71,1.71,0,0,0,216,137Zm.39,2.95a.84.84,0,0,0,.36-.73.81.81,0,0,0-.36-.7,1.85,1.85,0,0,0-1.08-.25h-1.94v1.92h2A1.77,1.77,0,0,0,216.34,139.91Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M224.08,134.24h1.34l-2.92,7h-1.08l-2.91-7h1.37l2.11,5.38Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M227.91,134.24v7h-1.22v-7Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 87,
    y: 137.27,
    width: 115,
    height: 1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 238,
    y: 137.27,
    width: 115,
    height: 1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 175,
    y: 59.34,
    width: 16,
    height: 62
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "345.5 59.34 326.5 59.34 348.25 90.34 326.5 121.34 345.5 121.34 367.25 90.34 345.5 59.34"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M369.25,95.8l16.87,24H370.78l-9.2-13.11,7.67-10.93m0-2.61-9.5,13.54L370,121.34h19L369.25,93.19Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M386.12,60.84l-16.87,24L361.58,74l9.2-13.11h15.34m2.88-1.5H370L359.75,74l9.5,13.54L389,59.34Z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "248 59.34 232.5 104.04 217 59.34 198.5 59.34 222.5 121.34 226.5 121.34 238.5 121.34 242.5 121.34 266.5 59.34 248 59.34"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "141.5 107.26 141.5 59.34 125.5 59.34 125.5 121.34 141.5 121.34 141.5 121.26 166.5 121.26 166.5 107.26 141.5 107.26"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "320 73.34 320 59.34 290 59.34 274 59.34 274 121.34 290 121.34 290 121.26 320 121.26 320 107.26 290 107.26 290 96.84 312 96.84 312 82.84 290 82.84 290 73.34 320 73.34"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M81.5,60.24V71.38c-9.19,1.54-15.5,9.16-15.5,19s6.31,17.42,15.5,19v11.14c-8.27-.7-15.39-3.89-20.67-9.28a30.18,30.18,0,0,1,0-41.64c5.28-5.39,12.4-8.58,20.67-9.28m1.5-1.6c-19.32.9-32,14.75-32,31.7S63.68,121.15,83,122V108c-9.39-.94-15.5-8.48-15.5-17.65S73.61,73.63,83,72.69v-14Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M87,58.64v14c9.39.94,15.5,8.48,15.5,17.65S96.39,107.05,87,108V122c19.32-.89,32-14.74,32-31.7S106.32,59.54,87,58.64Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoweredByFooter);
export default __webpack_public_path__ + "static/media/poweredBy-footer.be2c06a66360207985818b402ba02d2d.svg";
export { ForwardRef as ReactComponent };